export const REWARD__GET_IMMIDIATE = 'REWARD__GET_IMMIDIATE';
